import {
  Action,
  Actions,
  ActionSequence,
  wrapAction,
} from 'src/lib/ActionSequence';
import { State } from 'src/state';
import StateObserver from 'src/StateObserver';
import { defaultLaunchSequence } from './DefaultLaunchSequence';
import { adminLaunchSequence } from './AdminMessagesLaunchSequence';

/**
 * Creates launch sequence from an array of actions. The actions are executed in order.
 * @param actions
 * @returns
 */
export function createLaunchSequence(actions: Action[]): Actions {
  return actions;
}

/**
 * Creates a new launch sequence action block. Returning true from an action here, will only skip the block.
 * @param block
 * @returns
 */
export function actionBlock({
  actions,
  skip,
  enabled,
}: {
  actions: Actions;
  skip?: (state: State) => boolean;
  enabled?: (state: State) => boolean;
}): Action {
  return async () => {
    if (skip?.(StateObserver.getState())) {
      return false;
    }

    // Reverse to skip
    if (enabled && !enabled?.(StateObserver.getState())) {
      return false;
    }

    for (const action of actions) {
      if (await wrapAction(action).execute()) {
        break;
      }
    }

    return false;
  };
}

/**
 * Starts the active launch sequence.
 * @returns
 */
export async function startLaunchSequence(): Promise<void> {
  await ActionSequence.start(adminLaunchSequence, 'AdminMessages');
  await ActionSequence.start(defaultLaunchSequence, 'Launch');
}
